











 













const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "GitLabScopingSearchResultsRoot_meeting",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "GitLabScopingSearchResults_meeting"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "teamId",
      "storageKey": null
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "GitLabSearchQuery",
          "kind": "LinkedField",
          "name": "gitlabSearchQuery",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "queryString",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "selectedProjectsIds",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "PokerMeeting",
  "abstractKey": null
};

(node ).hash = "85858e169244f109d569bdf62bd6a980";

export default node;
